var DsMarqueeItem = class extends HTMLElement {
  constructor() {
    super(),
      window.ResizeObserver &&
        new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
  }
  _calculateDuration(entries) {
    // Warten bis DOM vollständig geladen ist
    setTimeout(() => {
      const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5);
      const contentWidth = entries[0].contentRect.width;
      const itemElement = entries[0].target.querySelector(".ds-scrolling-logo-list__items");
      
      // Prüfen ob das Element existiert
      if (!itemElement) {
        console.error("Marquee item element not found");
        return;
      }
      
      // Berechne Gesamtbreite aller Elemente
      const allItems = entries[0].target.querySelectorAll(".ds-scrolling-logo-list__items");
      let totalItemsWidth = 0;
      allItems.forEach(item => {
        totalItemsWidth += item.clientWidth;
      });
      
      // Sicherstellen, dass wir eine vernünftige Breite haben
      if (totalItemsWidth === 0) {
        totalItemsWidth = contentWidth;
      }
      
      // Angepasste Berechnungsformel für die Animation
      const slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / 1225;
      const duration = (scrollingSpeed * slowFactor * totalItemsWidth / contentWidth).toFixed(3);
      
      this.style.setProperty("--marquee-animation-duration", `${duration}s`);
    }, 0);
  }
};
if (!window.customElements.get('ds-marquee-item')) {
  window.customElements.define('ds-marquee-item', DsMarqueeItem);
}